"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Layout_1 = require("./Layout");
exports.default = Layout_1.default;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/containers/Layout/index.js
// module id = 1846
// module chunks = 8